import { Component, OnInit, Input } from '@angular/core';
import { getAcronym } from '@teem/helpers/functions';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { ProfileService } from '@teem/app/core/services/profile.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';

@Component({
  selector: 'cart-header',
  templateUrl: './cart-header.component.html',
  styleUrls: ['./cart-header.component.css']
})
export class CartHeaderComponent implements OnInit {
  @Input() customer: any;
  locale: string = 'en';
  totalCartItems: number = 0;

  constructor(
    private profileService: ProfileService,
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService,
    private customerAuthService: CustomerAuthService
  ) {}

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
    this.totalCartItems = (window as any).totalCartItems;

    console.log('this.customer')
    console.log(this.customer)
  }

  get customerAcronym() {
    return this.customer ? getAcronym(this.customer.first_name + ' ' + this.customer.last_name) : '';
  }

  logout(){
    this.profileService.logout([]).subscribe({
      next: (res) => {
        this.loaderService.stopLoading();
        this.customerAuthService.logout();
        this.sharedDataService.setItem('customerInfo', []);
        // window.location.reload();
      },
      error: (err) => {
        this.loaderService.stopLoading();
        const errors = err.error?.errors;
      },
    });
  }
}
